import noDataRowDirective from './noDataRow.directive';

const noDataRowModule = angular.module('app.common.table.noDataRow', [])
	.directive('noDataRow', noDataRowDirective)
	.name;

export default noDataRowModule;
